export default __webpack_public_path__ + "static/media/information.e6a98fb8.png";